import common from './common';
import sections from './sections';
import pages from './pages';
import captcha from './captcha';
import forgotPassword from './forgot-password';
import createPassword from './create-password';

export { common, sections, captcha, pages, forgotPassword, createPassword };
